export default "__VITE_ASSET__jnxLWsQH__"